import React from 'react';

const EyeButton = ({ room, roomIndex, setFieldValue, className, disabled }) => {
  const iconClass = room.enabled ? 'fa-eye' : 'fa-eye-slash';
  return (
    <div
      className={`flex justify-center text-center ${room.enabled ? 'text-orange-500' : 'text-gray-500'} text-lg ${className} ${disabled ? 'opacity-50' : ''}`}
    >
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (disabled) return;
          setFieldValue(`rooms.${roomIndex}.enabled`, !room.enabled);
        }}
        className={disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
      >
        <i className={'fa-solid ' + iconClass} />
      </div>
    </div>
  );
};

export default EyeButton;
